export const SECOND_TIMEOUT = 1000
export const TIME_FORMAT = 'mm:ss'
